import { isFeatureEnabled } from '../featureToggles.module'
import ahaSystem from '@/constant/ahaSystem'

const _getters = {
  canUseMultipleSessions: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'multiple-sessions')
  },
  canUseShareDocs: (_, getters, ___, rootGetters) => {
    return getters.canUseMultipleSessions && isFeatureEnabled(rootGetters, 'share-docs-with-multi-sessions')
  },
  isPresenterBeingSharedByEditor: (_, getters) => {
    return (presentation) => {
      return getters.canUseShareDocs && presentation?.User?.email === ahaSystem.email
    }
  },
  selectedSession: (state) => {
    return state.selectedSession
  },
  isRenderedReport: (state) => {
    return state.isRenderedReport
  },
  isCreatingNewSession: (state) => {
    return state.isCreatingNewSession
  },
  canLimitInviteSent: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-36749-rate-limit-invite')
  },
  canInvitePresenterToFolder: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-35166-invite-to-folder')
  },
}

export default _getters
